import React from 'react'
import { Button } from 'react-bootstrap'
import { SuitHeartFill } from 'react-bootstrap-icons'
import styles from './DonationBtn.module.scss'
import { Link, useNavigate } from 'react-router-dom'

export default function DonationBtn() {
    const navigate = useNavigate();
    return (
        <Link 
            to="/support-us"
            className={`${styles.btnMakeDonation}`}
        >
            <SuitHeartFill className={`${styles.icon}`} />
            Donate Now
        </Link>
    )
}
